import { Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useTranslation } from "react-i18next";

export function AdminRoute() {
  const { user } = useAuth();
  const { t } = useTranslation("errors");

  if (user?.currentMembership?.role !== "customer_admin") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive">
            {t("http.403")}
          </h1>
          <p className="mt-2 text-muted-foreground">
            {t("adminRequired", "この機能を利用するには管理者権限が必要です")}
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
